// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Styles */
.EpisodePlayScreen_container__8ALF1 {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #111;
  padding: 1rem;
}

.EpisodePlayScreen_card__JrEgj {
  display: flex;
  max-width: 1200px;
  gap: 4rem;
  background-color: #000;
  padding: 4rem;
  border-radius: 0.75rem;
}

.EpisodePlayScreen_imageSection__KfExZ {
  flex-shrink: 0;
  width: 400px;
}

.EpisodePlayScreen_coverImage__MXsrr {
  width: 100%;
  aspect-ratio: 1;
  border-radius: 0.5rem;
  object-fit: cover;
}

.EpisodePlayScreen_contentSection__NMIKL {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.EpisodePlayScreen_title__WBDqn {
  font-size: 2rem;
  font-weight: 700;
  color: white;
  margin-bottom: 0.5rem;
}

.EpisodePlayScreen_authorInfo__DDe7z {
  display: flex;
  gap: 2rem;
  color: #ffffff;
  margin-bottom: 1.5rem;
}

.EpisodePlayScreen_metadataSection__SeNRn {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
  padding: 1.5rem 0;
  margin-bottom: 2rem;
}

.EpisodePlayScreen_metadataItem__vBYLD {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-right: 1.5rem;
  border-right: 1px solid #1f2937;
}

.EpisodePlayScreen_metadataItem__vBYLD:last-child,
.EpisodePlayScreen_metadataItem__vBYLD:nth-child(2n) {
  border-right: none;
}

.EpisodePlayScreen_metadataLabel__WH-hm {
  color: #9ca3af;
}

.EpisodePlayScreen_metadataValue__84s6X {
  color: white;
}

.EpisodePlayScreen_description__5Fk8N {
  color: #e5e7eb;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.EpisodePlayScreen_listenNowButton__SEp8m  {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background-color: #ef4444 !important;
  color: white;
  padding: 0.75rem 2rem;
  border-radius: 9999px;
  width: fit-content;
  cursor: pointer;
  border: none;
  font-size: 1rem;
  font-weight: 500;
  transition: background-color 0.2s;
}

.EpisodePlayScreen_listenNowButton__SEp8m :hover {
  background-color: #dc2626;
}

/* Media Queries */

/* Large screens & Tablets (max-width: 1024px) */
@media (max-width: 1024px) {
  .EpisodePlayScreen_card__JrEgj {
    padding: 3rem;
    gap: 3rem;
  }

  .EpisodePlayScreen_imageSection__KfExZ {
    width: 350px;
  }

  .EpisodePlayScreen_title__WBDqn {
    font-size: 1.75rem;
  }

  .EpisodePlayScreen_authorInfo__DDe7z {
    gap: 1.5rem;
  }
}

/* Small tablets & small laptops (max-width: 768px) */
@media (max-width: 768px) {
  .EpisodePlayScreen_card__JrEgj {
    flex-direction: column;
    gap: 2rem;
    padding: 2rem;
  }

  .EpisodePlayScreen_imageSection__KfExZ {
    width: 100%;
  }

  .EpisodePlayScreen_metadataSection__SeNRn {
    grid-template-columns: 1fr;
  }

  .EpisodePlayScreen_metadataItem__vBYLD {
    border-right: none;
    border-bottom: 1px solid #1f2937;
    padding-bottom: 1rem;
  }

  .EpisodePlayScreen_metadataItem__vBYLD:last-child {
    border-bottom: none;
  }
}

/* Mobile Devices (max-width: 480px) */
@media (max-width: 480px) {
  .EpisodePlayScreen_card__JrEgj {
    padding: 1rem;
    gap: 1rem;
  }

  .EpisodePlayScreen_title__WBDqn {
    font-size: 1.5rem;
  }

  .EpisodePlayScreen_authorInfo__DDe7z {
    flex-direction: column;
    gap: 1rem;
  }

  .EpisodePlayScreen_button__oTXbW {
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
  }
}

/* Extra Small Devices (max-width: 320px) */
@media (max-width: 320px) {
  .EpisodePlayScreen_card__JrEgj {
    padding: 0.5rem;
    gap: 0.5rem;
  }

  .EpisodePlayScreen_title__WBDqn {
    font-size: 1.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/EpisodeScreen/Component/CSS/EpisodePlayScreen.module.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,0BAA0B;EAC1B,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;;AAElB,gDAAgD;AAChD;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,qDAAqD;AACrD;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Base Styles */\n.container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #111;\n  padding: 1rem;\n}\n\n.card {\n  display: flex;\n  max-width: 1200px;\n  gap: 4rem;\n  background-color: #000;\n  padding: 4rem;\n  border-radius: 0.75rem;\n}\n\n.imageSection {\n  flex-shrink: 0;\n  width: 400px;\n}\n\n.coverImage {\n  width: 100%;\n  aspect-ratio: 1;\n  border-radius: 0.5rem;\n  object-fit: cover;\n}\n\n.contentSection {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: white;\n  margin-bottom: 0.5rem;\n}\n\n.authorInfo {\n  display: flex;\n  gap: 2rem;\n  color: #ffffff;\n  margin-bottom: 1.5rem;\n}\n\n.metadataSection {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1rem;\n  border-top: 1px solid #fff;\n  border-bottom: 1px solid #fff;\n  padding: 1.5rem 0;\n  margin-bottom: 2rem;\n}\n\n.metadataItem {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding-right: 1.5rem;\n  border-right: 1px solid #1f2937;\n}\n\n.metadataItem:last-child,\n.metadataItem:nth-child(2n) {\n  border-right: none;\n}\n\n.metadataLabel {\n  color: #9ca3af;\n}\n\n.metadataValue {\n  color: white;\n}\n\n.description {\n  color: #e5e7eb;\n  margin-bottom: 2rem;\n  line-height: 1.6;\n}\n\n.listenNowButton  {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  background-color: #ef4444 !important;\n  color: white;\n  padding: 0.75rem 2rem;\n  border-radius: 9999px;\n  width: fit-content;\n  cursor: pointer;\n  border: none;\n  font-size: 1rem;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.listenNowButton :hover {\n  background-color: #dc2626;\n}\n\n/* Media Queries */\n\n/* Large screens & Tablets (max-width: 1024px) */\n@media (max-width: 1024px) {\n  .card {\n    padding: 3rem;\n    gap: 3rem;\n  }\n\n  .imageSection {\n    width: 350px;\n  }\n\n  .title {\n    font-size: 1.75rem;\n  }\n\n  .authorInfo {\n    gap: 1.5rem;\n  }\n}\n\n/* Small tablets & small laptops (max-width: 768px) */\n@media (max-width: 768px) {\n  .card {\n    flex-direction: column;\n    gap: 2rem;\n    padding: 2rem;\n  }\n\n  .imageSection {\n    width: 100%;\n  }\n\n  .metadataSection {\n    grid-template-columns: 1fr;\n  }\n\n  .metadataItem {\n    border-right: none;\n    border-bottom: 1px solid #1f2937;\n    padding-bottom: 1rem;\n  }\n\n  .metadataItem:last-child {\n    border-bottom: none;\n  }\n}\n\n/* Mobile Devices (max-width: 480px) */\n@media (max-width: 480px) {\n  .card {\n    padding: 1rem;\n    gap: 1rem;\n  }\n\n  .title {\n    font-size: 1.5rem;\n  }\n\n  .authorInfo {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .button {\n    padding: 0.5rem 1rem;\n    font-size: 0.9rem;\n  }\n}\n\n/* Extra Small Devices (max-width: 320px) */\n@media (max-width: 320px) {\n  .card {\n    padding: 0.5rem;\n    gap: 0.5rem;\n  }\n\n  .title {\n    font-size: 1.25rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EpisodePlayScreen_container__8ALF1`,
	"card": `EpisodePlayScreen_card__JrEgj`,
	"imageSection": `EpisodePlayScreen_imageSection__KfExZ`,
	"coverImage": `EpisodePlayScreen_coverImage__MXsrr`,
	"contentSection": `EpisodePlayScreen_contentSection__NMIKL`,
	"title": `EpisodePlayScreen_title__WBDqn`,
	"authorInfo": `EpisodePlayScreen_authorInfo__DDe7z`,
	"metadataSection": `EpisodePlayScreen_metadataSection__SeNRn`,
	"metadataItem": `EpisodePlayScreen_metadataItem__vBYLD`,
	"metadataLabel": `EpisodePlayScreen_metadataLabel__WH-hm`,
	"metadataValue": `EpisodePlayScreen_metadataValue__84s6X`,
	"description": `EpisodePlayScreen_description__5Fk8N`,
	"listenNowButton": `EpisodePlayScreen_listenNowButton__SEp8m`,
	"button": `EpisodePlayScreen_button__oTXbW`
};
export default ___CSS_LOADER_EXPORT___;
